import { CompanyRequestError } from '@/company/api';
import { formatCopy, namespaceCopyFor } from '@/i18n/ns';
import { localeLanguage } from '@/i18n/eu-locales';
import nativeConnectionsCopy from '@/i18n/ns/native-connections';
import type { CustomMcpAuthType, CustomMcpTransport, CustomMcpConnection } from './api';

export function authLabels(locale = 'en'): Record<CustomMcpAuthType, string> {
  const copy = namespaceCopyFor(nativeConnectionsCopy, localeLanguage(locale));
  return {
    none: copy.authNone,
    bearer: copy.authBearer,
    headers: copy.authHeaders,
    basic: copy.authBasic,
    oauth: copy.authOauth,
    shopify_dev_app: copy.authShopify,
  };
}

export function prettyTransport(value: CustomMcpTransport, locale = 'en') {
  const copy = namespaceCopyFor(nativeConnectionsCopy, localeLanguage(locale));
  if (value === 'builtin') return copy.transportBuiltin;
  return value === 'streamable_http'
    ? copy.transportHttp
    : value === 'sse'
      ? copy.transportSse
      : copy.transportAuto;
}

export function statusLabel(connection: CustomMcpConnection, locale = 'en') {
  const copy = namespaceCopyFor(nativeConnectionsCopy, localeLanguage(locale));
  if (connection.status === 'needs_authorization') return copy.statusNeedsAuth;
  if (connection.status === 'unavailable') return copy.statusUnavailable;
  return copy.statusConnected;
}

export function errorMessage(error: unknown, locale = 'en') {
  const copy = namespaceCopyFor(nativeConnectionsCopy, localeLanguage(locale));
  const messages: Record<string, string> = {
    custom_mcp_auth_required: copy.mcpAuthRequired,
    custom_mcp_url_blocked: copy.mcpUrlBlocked,
    custom_mcp_timeout: copy.mcpTimeout,
    custom_mcp_connection_failed: copy.mcpConnectionFailed,
    mcp_authorization_required: copy.mcpAuthorizationRequired,
    oauth_not_configured: copy.oauthNotConfigured,
    invalid_request: copy.mcpInvalidRequest,
    shopify_shop_invalid: copy.shopInvalid,
    shopify_shop_not_found: copy.shopNotFound,
    shopify_shop_not_permitted: copy.shopNotPermitted,
    shopify_app_not_installed: copy.shopNotInstalled,
    shopify_credentials_rejected: copy.shopCredentials,
    shopify_unavailable: copy.shopUnavailable,
  };
  if (error instanceof CompanyRequestError && Object.hasOwn(messages, error.code))
    return messages[error.code];
  return copy.mcpGenericError;
}
